import type { PayloadAction } from '@reduxjs/toolkit';
import { type Market, marketsInitialState, type MarketsState } from 'src/redux/markets/types';

const reducers = {
  setActiveMarketId: (state: MarketsState, action: PayloadAction<string | null>) => {
    state.activeMarketId = action.payload;
  },

  resetMarkets: (state: MarketsState) => {
    Object.assign(state, marketsInitialState);
  },

  clearMarketListData: (state: MarketsState) => {
    state.data = marketsInitialState.data;
  },

  setMarket: (state: MarketsState, action: PayloadAction<Market>) => {
    const market = action.payload;
    if (!market?.market_id) return;
    state.source[market.market_id] = { ...state.source[market.market_id], ...market };
    if (!state.data.data.includes(market.market_id)) {
      state.data.data.push(market.market_id);
    }
  },

  removeMarket: (state: MarketsState, action: PayloadAction<string>) => {
    const marketId = action.payload;
    if (!marketId) return;
    delete state.source[marketId];
    state.data.data = state.data.data.filter((id) => id !== marketId);
    state.data.meta.total = Math.max(0, (state.data.meta.total ?? 0) - 1);
  },

  clearMarketDetail: (state: MarketsState, action: PayloadAction<string | undefined>) => {
    const marketId = action.payload;
    if (marketId && state.source[marketId]) {
      delete state.source[marketId].market_properties;
      delete state.source[marketId].zip_codes;
      delete state.source[marketId].coordinator_ids;
      state.assignedZips = {};
    }
    state.marketDetailLoading = false;
  },

  clearAssignedZips: (state: MarketsState) => {
    state.assignedZips = {};
  },
};

export default reducers;
